import Cookies from "js-cookie";

const COOKIE_DOMAIN = "." + process.env.REACT_APP_BASE_DOMAIN_NEW;

export const StorageGetItem = (key) => {
    const raw = Cookies.get(key);
    if (!raw) return null;

    let result;
    try {
        result = JSON.parse(raw);
    } catch {
        Cookies.remove(key, { domain: COOKIE_DOMAIN, path: "/" });
        return null;
    }

    if (result.expireTime && result.expireTime <= Date.now()) {
        Cookies.remove(key, { domain: COOKIE_DOMAIN, path: "/" });
        return null;
    }
    return result.data;
};

export const StorageSetItem = (key, value, maxAge = 24 * 60 * 60 * 1000) => {
    const result = { data: value };
    if (maxAge) {
        result.expireTime = Date.now() + maxAge;
    }

    const str = JSON.stringify(result);

    Cookies.set(key, JSON.stringify(result), {
        domain: COOKIE_DOMAIN,
        path: "/",
        expires: maxAge / (24 * 60 * 60 * 1000), // js-cookie wants days, not ms
        sameSite: "lax",
        secure: window.location.protocol === "https:",
    });
};

export const StorageRemoveItem = (key) => {
    Cookies.remove(key, { domain: COOKIE_DOMAIN, path: "/" });
};